import {gql} from "@apollo/client";

export const LIVE_GAME_BROADCAST = gql`
    query LiveGameBroadcast($gameId: Int!) {
        liveGameBroadcast(gameId: $gameId) {
            id
            gameId
            provider
            title
            status
            playbackUrl
        }
    }
`;

export const GAME_BROADCASTS = gql`
    query GameBroadcasts($gameId: Int!) {
        streamingEnabled
        gameBroadcasts(gameId: $gameId) {
            id
            gameId
            provider
            title
            status
            playbackUrl
            createdAt
        }
    }
`;

export const LIVE_GAME_TIMELINE = gql`
    query LiveGameTimeline($gameId: Int!) {
        soccerPlayerScoresByGame(gameId: $gameId) {
            id
            minute
            period
            actionType
            player { id fullName }
            relatedPlayer { id fullName }
            team { id name }
        }
        hockeyPlayerScoresByGame(gameId: $gameId) {
            id
            minute
            second
            period
            actionType
            player { id fullName }
            relatedPlayer { id fullName }
            team { id name }
        }
    }
`;

export const EVENT_DETAIL_PUBLIC = gql`
query GetEventDetail($eventId: ID!) {
  eventDetail(eventId: $eventId) {
    id
        title
        description
        date
        status
        eventType
        address
        latitude
        longitude
        createdBy{
            id
        }
        season{
            name
            division{
                name
                organization{
                    name
                }
            }
        }
        field{
            id
            name
            sportFacility{
                latitude
                longitude
                address
            }
        }
        responsibles
        managers
        game{
            id
            homeTeam{
                id
                name
                logo
                players{
                    id
                    playerId
                    fullName
                    shirtNumber
                    status
                    position{
                        key
                        name
                    }
                    sanction{
                        type
                        gamesSuspended
                    }
                }
                role
            }
            visitorTeam{
                id
                name
                logo
                players{
                    id
                    playerId
                    fullName
                    shirtNumber
                    status
                    position{
                        key
                        name
                    }
                    sanction{
                        type
                        gamesSuspended
                    }
                }
                role
            }
            forfeitTeam{
                id
                name
                logo
            }
            scoreHome
            scoreVisitor
            resultType
            penaltiesHome
            penaltiesVisitor
            group{
                id
                name
            }
            matchDay
            gameAlias
            homeAway
            noPlay
        }
        trainingSession{
            id
            participants{
                id
                fullName
            }
        }
        competition{
            id
            participants{
                id
                fullName
            }
        }
        genericEvent{
            id
            participants{
                id
                fullName
            }
            address
            latitude
            longitude
        }
        attendances{
            profile{                
                id
                fullName                
            }
            confirmation
            attendance
        }
        invites{
            email
        }
        publicPhotos{
            id
            imageUrl
            thumbnailUrl
            caption
            createdAt
        }
  }
}
`;
